import { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home.tsx";
import Login from "./pages/Login.tsx";
import Register from "./pages/Register.tsx";
import Verification from "./pages/verification/Email.tsx";
import Dashboard from "./pages/dashboard/page.tsx";
import DashboardHistory from "./pages/dashboard/history.tsx";
import DashboardCommunity from "./pages/dashboard/community.tsx";
import DashboardAccount from "./pages/dashboard/account.tsx";
import DashboardPlaceholder from "./pages/dashboard/placeholder.tsx";
import Verify from "./pages/verify/Verify.tsx";
import Profile from "./pages/profile.tsx";
import Order from "./components/modules/order/OrderPage.js";
import OrderCheckout from "./pages/order/checkout/OrderCheckout.tsx";
import ScrollToHashElement from "./ScrollToHashElement.tsx";
import RedirectToSection from "./components/landing/RedirectToSection.tsx";
import { SECTION_IDS } from "./constants/sections.ts";
import { AuthProvider } from './contexts/AuthContext.tsx';
import ProtectedRoute from "./ProtectedRoute.tsx";
import "./styles/css/tailwind.css";
import "./styles/trading-theme.css";
import "./styles/sass/style.scss";

function App() {

  // const [userToken, setUserToken] = useState<string | null | undefined>(undefined);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   setUserToken(token);

  //   const handleStorageChange = () => {
  //     setUserToken(localStorage.getItem("token"));
  //   };

  //   window.addEventListener("storage", handleStorageChange);
  //   return () => window.removeEventListener("storage", handleStorageChange);
  // }, []);

  const [userToken, setUserToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Carregar token inicial
    const token = localStorage.getItem("token");
    setUserToken(token);
    setIsLoading(false);

    // Função para verificar mudanças no localStorage
    const checkTokenChange = () => {
      const newToken = localStorage.getItem("token");
      if (newToken !== userToken) {
        setUserToken(newToken);
      }
    };

    // Usar um intervalo para verificar mudanças (alternativa mais confiável)
    const intervalId = setInterval(checkTokenChange, 1000);

    // Event listener para storage (ainda útil para mudanças de outras abas)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "token") {
        setUserToken(e.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Adicione um loading state para evitar flashes
  if (isLoading) {
    return <div>Loading...</div>; // Ou um componente de loading
  }


  return (
    <AuthProvider>
      <Router>
        <ScrollToHashElement />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/free-plan"
            element={<RedirectToSection sectionId={SECTION_IDS.precos} />}
          />
          <Route path="/verification/:email" element={<Verification />} />
          <Route path="/verify/:token" element={<Verify />} />

          {/* Rotas públicas legadas → secções da landing */}
          <Route
            path="/price"
            element={<RedirectToSection sectionId={SECTION_IDS.precos} />}
          />
          <Route
            path="/about-us"
            element={<RedirectToSection sectionId={SECTION_IDS.sobre} />}
          />
          <Route
            path="/how-it-works"
            element={<RedirectToSection sectionId={SECTION_IDS.comoFunciona} />}
          />
          <Route
            path="/signals"
            element={<RedirectToSection sectionId={SECTION_IDS.sinais} />}
          />

          {/* Rotas protegidas */}
          <Route path="/profile" element={
            <ProtectedRoute >
              <Profile />
            </ProtectedRoute>
          } />

          <Route path="/order/:planId" element={
            <ProtectedRoute >
              <Order />
            </ProtectedRoute>
          } />
          <Route path="/order/checkout/:orderId" element={
            <ProtectedRoute >
              <OrderCheckout />
            </ProtectedRoute>
          } />

          <Route path="/dashboard" element={
            <ProtectedRoute >
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/history" element={
            <ProtectedRoute >
              <DashboardHistory />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/overview" element={
            <ProtectedRoute >
              <DashboardPlaceholder active="Dashboard" title="Dashboard" subtitle="Visao geral da sua atividade." />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/results" element={
            <ProtectedRoute >
              <DashboardPlaceholder active="Resultados" title="Resultados" subtitle="Resumo de desempenho dos sinais." />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/notifications" element={
            <ProtectedRoute >
              <DashboardPlaceholder active="Notificacoes" title="Notificações" subtitle="Centro de alertas e preferências." />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/community" element={
            <ProtectedRoute >
              <DashboardCommunity />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/account" element={
            <ProtectedRoute >
              <DashboardAccount />
            </ProtectedRoute>
          } />

          {process.env.NODE_ENV !== "production" && (
            <>
              <Route path="/dashboard-preview" element={<Dashboard preview />} />
              <Route path="/dashboard-history-preview" element={<DashboardHistory preview />} />
              <Route path="/dashboard-overview-preview" element={<DashboardPlaceholder preview active="Dashboard" title="Dashboard" subtitle="Visao geral da sua atividade." />} />
              <Route path="/dashboard-results-preview" element={<DashboardPlaceholder preview active="Resultados" title="Resultados" subtitle="Resumo de desempenho dos sinais." />} />
              <Route path="/dashboard-notifications-preview" element={<DashboardPlaceholder preview active="Notificacoes" title="Notificações" subtitle="Centro de alertas e preferências." />} />
              <Route path="/dashboard-community-preview" element={<DashboardCommunity preview />} />
              <Route path="/dashboard-account-preview" element={<DashboardAccount preview />} />
            </>
          )}



          <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
